import { useCallback } from 'react';
import { compose } from 'ramda';
import { useDispatch } from 'react-redux';

import { redirectTo } from '../store/location/actions';

export const useRedirect = () =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useCallback(compose(useDispatch(), redirectTo), []);
